<template>
  <v-snackbar
    v-model="snackbar.show"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    location="bottom"
    multi-line
  >
    {{ snackbar.message }}

    <template #actions>
      <v-btn
        v-if="snackbar.action"
        variant="text"
        :color="snackbar.action.color || 'white'"
        @click="handleActionClick"
      >
        {{ snackbar.action.label }}
      </v-btn>
      <v-btn
        variant="text"
        @click="snackbar.show = false"
      >
        {{ t('core.common.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useSnackbar } from '@/core/composables/useSnackbar'

const { t } = useI18n()
const { snackbar, hide } = useSnackbar()

function handleActionClick() {
  if (snackbar.action?.onClick) {
    snackbar.action.onClick()
    hide()
  }
}
</script>